/*
 * module.js - The description of the module.
 */

Fundu.Components.AllocatorSettings = (function($) {

    // State
    ///////////////////////////
    var _isInitialized = false;

    // Properties
    ///////////////////////////
    var _profileSelector = false;

    var _maxSharePerCompany = false;
    var _minAmountLeft = false;
    var _minCreditRating = false;
    var _maxLoanDuration = false;
    var _onlyJuniorLoans = false;

    var _activateAllocatorButton = false;
    var _disableAllocatorButtons = false;
    var _updateAllocatorParametersButton = false;

    var _allocatorActivateGuardModal = false;
    var _allocatorActivateGuardModalConfirmButton = false;
    var _allocatorDisableGuardModal = false;
    var _allocatorDisableGuardModalConfirmButton = false;
    var _allocatorUpdateGuardModal = false;
    var _allocatorUpdateGuardModalConfirmButton = false;

    var _sumPanel = false;
    var _sharePanel = false;
    var _creditRatingPanel = false;

    var _sumNumber = false;
    var _shareNumber = false;
    var _creditRatingNumber = false;

    var _allocatorBalance = false;
    var _allocatorMaxInvestment = false;

    var _investedAmount = false;
    var _accountBalance = false;

    var _allocatorFeeEnabled = false;
    var _allocatorFeeProvision = false;
    var _allocatorFeeConstant = false;

    // Private Methods
    ///////////////////////////

    // Select elements from HTML
    var selectElements = function() {
        _profileSelector = $("#profileSelector");

        _maxSharePerCompany = $("#maxSharePerCompany");
        _minAmountLeft = $("#minAmountLeft");
        _minCreditRating = $("#minCreditRating");
        _maxLoanDuration = $("#maxLoanDuration");
        _onlyJuniorLoans = $("#onlyJuniorLoans");

        _activateAllocatorButton = $("#activateAllocatorButton");
        _disableAllocatorButtons = $(".disable-button");
        _updateAllocatorParametersButton= $("#updateAllocatorParametersButton");

        _allocatorActivateGuardModal = $("#allocatorActivateGuard");
        _allocatorActivateGuardModalConfirmButton = $("#allocatorActivateGuardConfirm");
        _allocatorDisableGuardModal = $("#allocatorDisableGuard");
        _allocatorDisableGuardModalConfirmButton = $("#allocatorDisableGuardConfirm");
        _allocatorUpdateGuardModal = $("#allocatorUpdateGuard");
        _allocatorUpdateGuardModalConfirmButton = $("#allocatorUpdateGuardConfirm");

        _sumPanel = $("#sumPanel");
        _sharePanel = $("#sharePanel");
        _creditRatingPanel = $("#creditRatingPanel");

        _sumNumber = $("#sumNumber");
        _shareNumber = $("#shareNumber");
        _creditRatingNumber = $("#creditRatingNumber");

        _allocatorBalance = $("#allocatorBalance");
        _allocatorMaxInvestment = $("#allocatorMaxInvestment");

        _investedAmount = $("#investedAmount");
        _accountBalance = $("#accountBalance");

        _allocatorFeeEnabled = $("#allocatorFeeEnabled");
        _allocatorFeeProvision = $("#allocatorFeeProvision");;
        _allocatorFeeConstant = $("#allocatorFeeConstant");;
    };

    var initializeAllocatorFields = function() {
        if (_minAmountLeft.length > 0) {
            _minAmountLeft.on('keyup', function() {
                highlightPanels();
                displayAllocatorValues();
            });
        }

        if (_maxSharePerCompany.length > 0) {
            _maxSharePerCompany.on('change', function() {
                highlightPanels();
                displayAllocatorValues();
            });
        }

        highlightPanels();
        displayAllocatorValues();
    }

    var displayAllocatorValues = function() {
        _allocatorBalance.text(formatAllocatorBalance(getAllocatorBalance()));
        _allocatorMaxInvestment.text(formatMaxInvestment(getMaxInvestment()));
    }

    var highlightPanels = function() {

        var activePanelClass = "allocator-panel-active";

        if (_minAmountLeft.val() != null && _minAmountLeft.val() != "") {
            _sharePanel.addClass(activePanelClass);
            _shareNumber.addClass(activePanelClass);

            if (_maxSharePerCompany.val() != null) {
                _creditRatingPanel.addClass(activePanelClass);
                _creditRatingNumber.addClass(activePanelClass);
            }
        } else {
            _sharePanel.removeClass(activePanelClass);
            _shareNumber.removeClass(activePanelClass);

            _creditRatingPanel.removeClass(activePanelClass);
            _creditRatingNumber.removeClass(activePanelClass);
        }

    }

    var initializeMobilePanels = function() {
        _sumNumber.on('click', function() { showSumPanel() });
        _shareNumber.on('click', function() { showSharePanel() });
        _creditRatingNumber.on('click', function() { showCreditRatingPanel() });
    }

    var resetPanels = function() {
        togglePanels(_sumNumber, _sumPanel);
        togglePanels(_shareNumber, _sharePanel);
        togglePanels(_creditRatingNumber, _creditRatingPanel);
    }

    var showSumPanel = function() {
        resetPanels();
        togglePanels(_sumPanel, _sumNumber);
    }

    var showSharePanel = function() {
        resetPanels();
        togglePanels(_sharePanel, _shareNumber);
    }

    var showCreditRatingPanel = function() {
        resetPanels();
        togglePanels(_creditRatingPanel, _creditRatingNumber);
    }

    var togglePanels = function(display, hide) {
        var displayClasses = "col-xs-12 col-sm-12 col-md-12";
        var hiddenClasses = "hidden-xs hidden-sm hidden-md";

        display.removeClass(hiddenClasses);
        display.addClass(displayClasses);

        hide.addClass(hiddenClasses);
        hide.removeClass(displayClasses);
    }

    var initializeProfileSelector = function () {
        _profileSelector.on('change', function () {

            var profileId = undefined;
            var selectedProfile = _profileSelector.val();

            if (selectedProfile !== "personal") {
                profileId = selectedProfile;
            }

            window.location.replace(jsRoutes.controllers.AllocatorCtrl.view(profileId).url);
        });
    };

    var getData = function(enabled) {
        return {
            enabled: enabled,
            max_share_per_company:  _maxSharePerCompany.val() != null ? _maxSharePerCompany.val().replace(",", ".") : "",
            min_amount_left:        _minAmountLeft.val().replace(",", ".").trim(),
            min_credit_rating:      _minCreditRating.val(),
            max_loan_duration:      _maxLoanDuration.val(),
            only_junior_loans:      (_onlyJuniorLoans.attr('type') === 'checkbox' ? _onlyJuniorLoans[0].checked : undefined)
        };
    };

    var initializeAllocatorButtons = function () {
        if(_activateAllocatorButton.length > 0) {
            _activateAllocatorButton.on('click', function () { if(validateAllocatorData()) { showAllocatorActivateGuard() }});
        }

        if(_disableAllocatorButtons.length > 0) {
            _disableAllocatorButtons.on('click', function () { showAllocatorDisableGuard() });
        }

        if(_updateAllocatorParametersButton.length > 0) {
            _updateAllocatorParametersButton.on('click', function () { if(validateAllocatorData()) { showAllocatorUpdateGuard() }});
        }
    };

    var validateAllocatorData = function() {

        resetErrors();
        var values = getData();
        var errorKey = null;

        if (values.min_amount_left === "" || isNaN(values.min_amount_left)) {
            errorKey = "min_amount_left";
            _minAmountLeft.addClass("error");
        }

        if (values.max_share_per_company === null || values.max_share_per_company === "") {
            errorKey = errorKey === null ? "max_share_per_company" : errorKey;
            _maxSharePerCompany.addClass("error");
        }

        if (values.min_credit_rating === null || values.min_credit_rating === "") {
            errorKey = errorKey === null ? "min_credit_rating" : errorKey;
            _minCreditRating.addClass("error");
        }

        if (values.max_loan_duration === null || values.max_loan_duration === "") {
            errorKey = errorKey === null ? "max_loan_duration" : errorKey;
            _maxLoanDuration.addClass("error");
        }

        if (errorKey) {
            Fundu.Helpers.Notify.error("global", "error.allocator." + errorKey);
        }

        return errorKey === null;
    }

    var resetErrors = function() {
        $('.error').removeClass("error");
        Fundu.Helpers.Notify.hide();
    }

    var showAllocatorActivateGuard = function () {
        var modelContent = $("<div></div>");
        modelContent.append($("<p></p>").text(Fundu.Helpers.Notify.translate("common.allocator.activate-guard.description")));
        modelContent.append(buildParametersTable());
        modelContent.append(buildAllocatorFeeMessage());

        Fundu.Helpers.Modal.setModalContent("common.allocator.activate-guard.title", modelContent);
        Fundu.Helpers.Modal.setModalButtons([
            {text: "common.actions.cancel", closeModal: true},
            {text: "common.allocator.activate-guard.confirm", callback: function () { turnOn(); Fundu.Helpers.Modal.closeModal(); }}
        ]);
        Fundu.Helpers.Modal.showModal();
    };

    var showAllocatorUpdateGuard = function () {
        var modelContent = $("<div></div>");
        modelContent.append($("<p></p>").text(Fundu.Helpers.Notify.translate("common.allocator.update-guard.description")));
        modelContent.append(buildParametersTable());
        modelContent.append(buildAllocatorFeeMessage());

        Fundu.Helpers.Modal.setModalContent("common.allocator.update-guard.title", modelContent);
        Fundu.Helpers.Modal.setModalButtons([
            {text: "common.actions.cancel", closeModal: true},
            {text: "common.allocator.update-guard.confirm", callback: function () { updateParameters(true); Fundu.Helpers.Modal.closeModal(); }}
        ]);
        Fundu.Helpers.Modal.showModal();
    };

    var getAllocatorBalance = function() {
        var investedAmount =  Fundu.Helpers.Formats.getNumberValue(_investedAmount);
        var accountBalance = Fundu.Helpers.Formats.getNumberValue(_accountBalance);
        var minAmountLeft = !isNaN(_minAmountLeft.val().replace(",", ".").trim()) ? _minAmountLeft.val().replace(",", ".").trim() : 0.00;

        return accountBalance + investedAmount - minAmountLeft;
    }

    var getMaxInvestment = function() {
        var maxSharePerCompany = _maxSharePerCompany.val() != null ? _maxSharePerCompany.val().replace(",", ".") : 0.00;

        return getAllocatorBalance() * (maxSharePerCompany / 100);
    }

    var formatAllocatorBalance = function(allocatorBalance) {
        var allocatorBalanceString = "";

        if (allocatorBalance < 0) {
            allocatorBalanceString = Fundu.Helpers.Notify.translate("common.allocator.text.allocator_sum_negative");
        } else {
            allocatorBalanceString = Fundu.Helpers.Formats.formatCurrency(getAllocatorBalance().toFixed(2) + " €");
        }

        return allocatorBalanceString;
    }

    var formatMaxInvestment = function(maxInvestment) {
        var maxInvestmentString = "";

        if (maxInvestment < 10) {
            maxInvestmentString = Fundu.Helpers.Notify.translate("common.allocator.text.max_invest_too_small");
        } else {
            maxInvestmentString = Fundu.Helpers.Formats.formatCurrency(maxInvestment.toFixed(2) + " €");
        }

        return maxInvestmentString;
    }

    var buildParametersTable = function () {
        var table = $("<table id='allocatorGuardParametersTable'></table>");
        var parameterValues = getData(true);

        var tableBody = $("<tbody></tbody>");

        tableBody.append(buildParameterTableRow(Fundu.Helpers.Notify.translate("common.allocator.guard.min_amount_left"), Fundu.Helpers.Formats.formatCurrency(parameterValues.min_amount_left) + " €"));
        tableBody.append(buildParameterTableRow(Fundu.Helpers.Notify.translate("common.allocator.guard.max_share_per_company"), parameterValues.max_share_per_company + " %"));

        tableBody.append(buildParameterTableRow(Fundu.Helpers.Notify.translate("common.allocator.guard.min_credit_rating"), _minCreditRating.find("option:selected").text().trim()));
        tableBody.append(buildParameterTableRow(Fundu.Helpers.Notify.translate("common.allocator.guard.max_loan_duration"), _maxLoanDuration.find("option:selected").text().trim()));

        if (parameterValues.only_junior_loans !== undefined) {
            tableBody.append(buildParameterTableRow(Fundu.Helpers.Notify.translate("common.allocator.guard.only_junior_loans"), Fundu.Helpers.Notify.translateYesOrNo(parameterValues.only_junior_loans)));
        }

        tableBody.append(buildParameterTableRow(Fundu.Helpers.Notify.translate("common.allocator.guard.allocator_sum"), formatAllocatorBalance(getAllocatorBalance())));
        tableBody.append(buildParameterTableRow(Fundu.Helpers.Notify.translate("common.allocator.guard.max_investment"), formatMaxInvestment(getMaxInvestment())));

        table.append(tableBody);

        return table;
    };

    var buildParameterTableRow = function (paramName, value) {
        var row = $("<tr></tr>");
        row.append($("<td></td>").text(paramName));
        row.append($("<td></td>").text(value));

        return row;
    };

    var buildAllocatorFeeMessage = function() {
        var message = $("<div></div>").attr("class", "allocator-fee-message");
        var allocatorFeeText = "";

        if (_allocatorFeeEnabled.text() == "true") {
            var allocatorFeeProvision = Fundu.Helpers.Formats.getNumberValue(_allocatorFeeProvision);
            var allocatorFeeConstant = Fundu.Helpers.Formats.getNumberValue(_allocatorFeeConstant);

            var chargingFeeText = Fundu.Helpers.Notify.translate("common.allocator.guard.fee");

            if (allocatorFeeConstant == 0 && allocatorFeeProvision == 0) {
                allocatorFeeText = Fundu.Helpers.Notify.translate("common.allocator.guard.fee_free_all");
            } else if (allocatorFeeConstant != 0 && allocatorFeeProvision == 0) {
                allocatorFeeText = chargingFeeText + " " + Fundu.Helpers.Formats.formatCurrency(allocatorFeeConstant) + " €";
            } else if (allocatorFeeProvision != 0 && allocatorFeeConstant == 0) {
                allocatorFeeText = chargingFeeText + " " + allocatorFeeProvision + " %";
            } else {
                allocatorFeeText = chargingFeeText + " " + allocatorFeeProvision + " % + " + Fundu.Helpers.Formats.formatCurrency(allocatorFeeConstant) + " €";
            }
        } else {
            allocatorFeeText = Fundu.Helpers.Notify.translate("common.allocator.guard.fee_free");
        }

        return message.text(allocatorFeeText);
    }

    var showAllocatorDisableGuard = function () {
        var modelContent = $("<div></div>");
        modelContent.append($("<p></p>").text(Fundu.Helpers.Notify.translate("common.allocator.disable-guard.description")));

        Fundu.Helpers.Modal.setModalContent("common.allocator.disable-guard.title", modelContent);
        Fundu.Helpers.Modal.setModalButtons([
            {text: "common.actions.cancel", closeModal: true},
            {text: "common.allocator.disable-guard.confirm", callback: function () { turnOff(); Fundu.Helpers.Modal.closeModal(); }}
        ]);
        Fundu.Helpers.Modal.showModal();
    };

    var turnOn = function() {
        var data = getData(true);
        updateSettings(data, "redirect");
    };

    var updateParameters = function(enabled) {
        var data = getData(enabled);
        updateSettings(data, "");
    };

    var turnOff = function() {

        $.ajax({
            type: "PUT",
            contentType: "application/json",
            data: JSON.stringify({}),
            url: jsRoutes.controllers.AllocatorCtrl.disableAllocator(getProfileId()).url
        }).done(function(res) {
            if(res && res.success === true) {
                window.location.replace(window.location.href);
            } else {
                Fundu.Helpers.Notify.error("global", "error.generic");
            }
        }).fail(function(res) {
            Fundu.Helpers.Notify.error("global", "error.generic");
        })
    };

    var updateSettings = function(data, onSuccess) {

        resetErrors();

        if(data.only_junior_loans === undefined) data.only_junior_loans = false;

        $.ajax({
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(data),
            url: jsRoutes.controllers.AllocatorCtrl.updateSettings(getProfileId()).url
        }).done(function(res) {
            // res could be parsed into JSON, but that would require exception handling. This is simpler.
            if(!res || res.success !== true) {
                Fundu.Helpers.Notify.error("global", "error.generic");
            } else if (onSuccess === "redirect") {
                window.location.replace(window.location.href);
            } else {
                Fundu.Helpers.Notify.success("global", "success.settings.save");
            }
        }).fail(function(res) {
            var errors = res.responseJSON.errors;
            if (errors.hasOwnProperty('max_share_per_company')) {
                Fundu.Helpers.Notify.error("global", "error.allocator.max_share_per_company");
                _maxSharePerCompany.addClass("error");
            } else if (errors.hasOwnProperty('min_amount_left')) {
                Fundu.Helpers.Notify.error("global", "error.allocator.min_amount_left");
                _minAmountLeft.addClass("error");
            } else if (errors.hasOwnProperty('amount_left_after_allocation')) {
                Fundu.Helpers.Notify.error("global", "error.allocator.min_credit_rating");
                _minCreditRating.addClass("error");
            } else {
                Fundu.Helpers.Notify.error("global", "error.generic");
            }
        })
    };

    var getProfileId = function() {
        var profileId = undefined;
        var queryString = window.location.search;
        var queryStringSplitted = queryString.split("profileId=")[1];

        if (queryStringSplitted) {
            profileId = queryStringSplitted.split("&")[0];
        }

        return profileId;
    };


    // Init
    ///////////////////////////
    var initialize = function() {
        if(_isInitialized) return true;

        selectElements();
        initializeProfileSelector();
        initializeAllocatorButtons();
        initializeAllocatorFields();
        initializeMobilePanels();

        // disable form submit on Enter-key press on <input type=text>
        $(document).on('keyup keypress', 'form input[type="text"]', function (e) {
            if (e.which == 13) {
                e.preventDefault();
                return false;
            }
        });

        _isInitialized = true;
        return true;
    };


    // Public Methods
    ///////////////////////////

    // Reveal public methods
    return {
        init: initialize
    }


})(jQuery);
